import React, { useEffect } from "react";
import banner from "../assets/images/journey-banner.png";

import bannermobile from "../assets/images/journey-banner-mobile.jpg";
import aboutBannerLogo from "../assets/images/journeyba-logo.png";
import { Helmet } from "react-helmet";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { useTranslation } from "react-i18next";
import "../journey-versions-v1.css";
import icon2026 from "../assets/images/icons/great-place-to-work.png";
import icon2027 from "../assets/images/icons/innovation.png";
import icon2028 from "../assets/images/icons/rebrnding-image.png";
import icon2029 from "../assets/images/icons/mobile-App.png";
import icon2030 from "../assets/images/icons/patent-certificate.png";
import icon2031 from "../assets/images/icons/ipo-nse-bse.png";
import icon2032 from "../assets/images/icons/merger-corporate.png";
import icon2033 from "../assets/images/icons/industrial-plane.png";
import icon2034 from "../assets/images/icons/colabration-merger.png";
import icon2035 from "../assets/images/icons/partnership.png";
import icon2036 from "../assets/images/icons/manufacturing-plant.png";


const JourneyV1 = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("visible");
                        const iconBox = entry.target.querySelector(".icon-box");
                        if (iconBox) {
                            iconBox.classList.add("animate-in");
                            setTimeout(() => {
                                iconBox.classList.add("bounce");
                            }, 800);
                        }
                    }
                });
            },
            { threshold: 0.1 }
        );

        const items = document.querySelectorAll(".animate-item");
        items.forEach((item) => observer.observe(item));

        return () => observer.disconnect();
    }, []);

    const timelineData = [
        { year: "2026", textKey: "txt2026", items: ["txt1", "txt2"], icon: icon2026 },
        { year: "2025", textKey: "txt2025", items: ["txt1", "txt2"], icon: icon2027 },
        { year: "2024", textKey: "txt2024", items: ["txt1", "txt2", "txt3"], icon: icon2028 },
        { year: "2023", textKey: "txt2023", items: ["txt1", "txt2", "txt3", "txt4"], icon: icon2029 },
        { year: "2022", textKey: "txt2022", items: ["txt1", "txt2", "txt3"], icon: icon2030 },
        { year: "2021", textKey: "txt2021", items: ["txt1", "txt2"], icon: icon2031 },
        { year: "2020", textKey: "txt2020", items: ["txt1", "txt2", "txt3"], icon: icon2032 },
        { year: "2019", textKey: "txt2019", items: ["txt1"], icon: icon2033 },
        { year: "2017", textKey: "txt2017", items: ["txt1"], icon: icon2034 },
        { year: "2016", textKey: "txt2016", items: ["txt1"], icon: icon2035 },
        { year: "2014", textKey: "txt2014", items: ["txt1"], icon: icon2036 },
    ];

    return (
        <div className="journey-page journey-v1">
            <Helmet>
                <title>{t("SEO.journey.title")}</title>
                <meta name="keywords" description="" />
                <meta name="description" content={t("SEO.journey.desc")} />
                <link rel="canonical" href={window.location.origin + window.location.pathname} />
                <link rel="alternate" hreflang="en" href={t("SEO.journey.alternateLinks.en")} />
                <link rel="alternate" hreflang="gu" href={t("SEO.journey.alternateLinks.guj")} />
                <link rel="alternate" hreflang="hi" href={t("SEO.journey.alternateLinks.hi")} />
                <link rel="alternate" hreflang="x-default" href={t("SEO.journey.canLink")} />
            </Helmet>

            <div className="banner text-center position-relative">
                <img className="desktopbannerinner" src={banner} alt="" />
                <img className="mobilebannerinner" src={bannermobile} alt="" />
                <article className="position-absolute text-center">
                    <span className="d-flex justify-content-center align-items-center mx-auto">
                        <img src={aboutBannerLogo} alt="" />
                    </span>
                    <h1 className="text-uppercase">{t("our_journey.title")}</h1>
                </article>
                <div className="breadouter">
                    <div className="container">
                        <Breadcrumb className="mb-0 py-2">
                            <Breadcrumb.Item href="#">{t("breadcrumb.home")}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{t("our_journey.title")}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
            </div>

            <section className="section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">

                            <ul className="timeline">
                                {timelineData.map((entry, index) => (
                                    <li key={entry.year} className={`${index % 2 !== 0 ? "timeline-inverted" : ""} animate-item`}>
                                        <div className="timeline-image">
                                            <span>{entry.year}</span>
                                        </div>

                                        <div className="timeline-panel">
                                            <div className="timeline-heading">
                                                <h4>{entry.year} Milestones</h4>
                                            </div>
                                            <div className="timeline-body">
                                                <ul>
                                                    {entry.items.map((key) => (
                                                        <li key={key}>
                                                            <i className="fas fa-check-circle list-icon"></i>
                                                            <span dangerouslySetInnerHTML={{
                                                                __html: t(`our_journey.${entry.textKey}.${key}`).replace(/<br\s*\/?>/gi, " "),
                                                            }}></span>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="icon-box">
                                            <img
                                                src={entry.icon}
                                                alt="Icon"
                                                className="icon-image"
                                                style={{ width: '100px' }}
                                            />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default JourneyV1;
